import React from 'react';
import { connect } from 'react-redux';
import UserPage from '../../views/UserPage/UserPage';
import {
  loadingUsersSelector,
  usersErrorSelector,
  userSelector,
  userPickUpsSelector,
  userPickUpsCountSelector,
  productsSelector
} from './selectors';
import { actions } from './slice';
import { actions as pickUpActions } from '../PickUps/slice';
import { availabilitiesSelector } from '../PickUps/selectors';
import promisifyActions from '../../lib/utils/promisify-actions';

const User = props => {
  return <UserPage {...props} />;
};

/**
 * The admin state to be provided to the admin component
 *
 * @param {object} state global state
 */
const mapStateToProps = state => ({
  availabilities: availabilitiesSelector(state),
  error: usersErrorSelector(state),
  loading: loadingUsersSelector(state),
  pickUps: userPickUpsSelector(state),
  pickUpsCount: userPickUpsCountSelector(state),
  user: userSelector(state),
  products: productsSelector(state)
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch admin adminActions
 */
const mapDispatchToProps = dispatch => ({
  addPickUp: pickUp =>
    dispatch(actions.addUserPickUp({ pickUp, userId: pickUp.customerId })),
  downloadPickUpScans: (userId, pickUpId) =>
    dispatch(actions.downloadUserPickUpScans({ userId, pickUpId })),
  getAvailabilities: (userId, params) =>
    dispatch(pickUpActions.getAvailabilities({ userId, params })),
  getPickUps: (params, userId) =>
    dispatch(actions.getUserPickUps({ params, userId })),
  getUser: userId => dispatch(actions.getUser({ userId })),
  getProducts: () => dispatch(actions.getDigitalProducts()),
  unlockHDScans: (userId, params) =>
    dispatch(actions.unlockHDScans({ userId, params })),
  unlockTiffScans: (userId, params) =>
    dispatch(actions.unlockTiffScans({ userId, params })),
  updateUser: (userId, update) =>
    dispatch(actions.updateUser({ userId, update })),
  removeAddress: (userId, addressId) =>
    dispatch(actions.removeAddress({ userId, addressId })),
  updatePickUp: pickUp =>
    dispatch(actions.updateUserPickUp({ pickUp, userId: pickUp.customerId }))
});

/**
 * Connects admin state to the App component
 *
 * @param {object} mapStateToProps admin data object to become props for the App component
 * @param {object} mapDispatchToProps admin adminActions to be dispatched to reducer
 */
export default connect(
  mapStateToProps,
  promisifyActions(mapDispatchToProps)
)(User);
